import React from 'react';
import { IoArrowForward } from 'react-icons/io5';
import './Button.css';

function Button({ 
  children, 
  onClick, 
  variant = 'primary', 
  showArrow = true,
  to,
  className = ''
}) {
  const buttonClass = `btn btn-${variant} ${className}`;

  if (to) {
    return (
      <a href={to} className={buttonClass} onClick={onClick}>
        {children}
        {showArrow && <IoArrowForward className="btn-arrow" />}
      </a>
    );
  }

  return (
    <button className={buttonClass} onClick={onClick}>
      {children}
      {showArrow && <IoArrowForward className="btn-arrow" />}
    </button>
  );
}

export default Button;
